import { ethers } from 'ethers'
import React, { useState, useEffect } from 'react';
import { chainConnectionsIds, CHAIN_CONNECTIONS, CHAIN_IDS } from '../config';
import Sidebar from './Sidebar';
import WaterRippleCursor from './WaterRippleCursor.js';
import CustomDropdown from './CustomDropdown.js';
import Header from './Header';
import SurferMonkeyWidget from './SurferMonkeyWidget';
import Carousel from './Carousel';
import MetaMask from '../Images/MetaMask.png'
import LandingImage from '../Images/SurferMonkey blockchain zkp privacy regulatory compliance landing playground.webp'
import '../Styles/LandingPage.css';

const LandingPage = () => {
    // set global variables
    const [blockchainInfo, setBlockchainInfo] = useState({});
    const [chainSelected, setchainSelected] = useState([])
    const [selectedValue, setSelectedValue] = useState(CHAIN_IDS.ETHEREUM);
    const [userMessage, setUserMessage] = useState(null);
    const [showWidget, setShowWidget] = useState(false);

    //For the first print message to show the supported chains
    const supportedNetworks = Object.values(CHAIN_CONNECTIONS).map(chain => chain.networkName);

    useEffect(() => {
        // perform blockchain connection on page load
        //connect();
    }, []);

    const closeWidget = () => {
        setShowWidget(false);
    };

    async function connect() {
        try {
            // Initialize the blockchain provider
            const provider = new ethers.BrowserProvider(window.ethereum, "any");
            // Handle network changes to refresh the page
            provider.on("network", (newNetwork, oldNetwork) => {
                if (oldNetwork) {  // If oldNetwork exists, the network has changed
                    console.log(`Network changed from ${oldNetwork} to ${newNetwork}. Reloading page...`);
                    window.location.reload();
                }
            });

            // Request user to connect their wallet
            let x = await provider.send("eth_requestAccounts", []);

            // Obtain the signer from the connected wallet
            const signer = await provider.getSigner();

            // Fetch the connected wallet's address
            const address = await signer.getAddress();

            // Format the wallet address for display
            const shortenedAddress = `${address.substr(0, 5)}...${address.substr(38, 42)}`;
            document.getElementById("connectBtn").innerHTML = shortenedAddress;
            document.getElementById("connectBtn").disabled = true;

            // Retrieve the current chain ID
            const networkData = await provider.getNetwork();
            const currentChainId = networkData.chainId;  // Extract networkId from the network data
            console.log(`Connected to chain ID: ${currentChainId}`);

            // Check the connection and update the DOM based on the chain ID
            checkConnectionAndUpdateDOM(Number(currentChainId));

        } catch (error) {
            document.getElementById("wrong").style.display = "flex";
            console.error("Error during wallet connection:", error);
        }
    }

    // Check the connection. If the network is wrong, display an error. 
    // Otherwise, manipulate the DOM for the correct chain.
    // pass the wntworkID 8001, etc
    function checkConnectionAndUpdateDOM(chainId) {
        // Get all supported chain values from the CHAIN_CONNECTIONS structure
        const supportedChainIds = Object.values(CHAIN_CONNECTIONS).map(details => details.networkId);
        if (supportedChainIds.includes(chainId)) {
            // Find the appropriate chain details based on the provided chainId. SurferMonkey IDs: 1,2,3,4,5...
            const matchedChainKey = Object.keys(CHAIN_CONNECTIONS).find(key => CHAIN_CONNECTIONS[key].networkId === chainId);
            console.log(matchedChainKey, typeof (matchedChainKey), "HEREEEEE")

            // Display the content
            document.getElementById("wrong").style.display = "none";
            document.getElementById("Sidebar").style.display = "flex";
            document.getElementById("LandingImageID").style.visibility = "hidden";

            // Update the states with the relevant chain details
            setSelectedValue(Number(matchedChainKey));
            setchainSelected(CHAIN_CONNECTIONS[matchedChainKey].networkId);

            // Update blockchain info object for the dapp selection
            let supportedDapps = CHAIN_CONNECTIONS[matchedChainKey].supportedDapps ? CHAIN_CONNECTIONS[matchedChainKey].supportedDapps : [];
            let supportedTokens = CHAIN_CONNECTIONS[matchedChainKey].supportedTokens ? CHAIN_CONNECTIONS[matchedChainKey].supportedTokens : [];
            let supportedUniSwapTokens = CHAIN_CONNECTIONS[matchedChainKey].supportedUniSwapTokens ? CHAIN_CONNECTIONS[matchedChainKey].supportedUniSwapTokens : [];
            setBlockchainInfo(prevInfo => ({
                /*...prevInfo,*/
                active: CHAIN_CONNECTIONS[matchedChainKey].active,
                name: CHAIN_CONNECTIONS[matchedChainKey].networkName,
                sourceChainId: matchedChainKey,
                supportedDapps: supportedDapps,
                supportedTokens: supportedTokens,
                logo: CHAIN_CONNECTIONS[matchedChainKey].logo,
                universalUP: CHAIN_CONNECTIONS[matchedChainKey].universalUP,
                supportedUniSwapTokens: supportedUniSwapTokens
            }));

            // If needed, additional logic can be added for each chain here

            // Load saved counters (if necessary)
            // await loadCounter(chain);
            return true
        } else {
            document.getElementById("wrong").style.display = "flex";
            console.log("Error: Unsupported network detected.");
            return false
        }
    }


    // Return chainId
    function getCurrentChainProvider() {
        // Get the current network ID from the provider
        const chainNetworkId = Number(window.ethereum.networkVersion);

        let x = checkConnectionAndUpdateDOM(chainNetworkId)

        // Obtain the value of the chainId, 1,2,3,4...
        if (x) {
            const matchedChainKey = Object.keys(CHAIN_CONNECTIONS).find(key => CHAIN_CONNECTIONS[key].networkId === chainNetworkId);
            return matchedChainKey
        } else {
            return null
        }
    }

    // Perform blockchain switch
    async function switchNet(value) {
        const chainId = chainConnectionsIds[value - 1];
        await setConnection(chainId);
    }

    // Unified function to set connection based on the chain ID
    async function setConnection(chainId) {
        const chainInfo = CHAIN_CONNECTIONS[chainId];

        if (!chainInfo) {
            console.error(`Invalid chain ID: ${chainId}`);
            return;
        }

        try {
            // Request to switch Ethereum chain
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: chainInfo.networkIdHex }],
            });

            setchainSelected(chainInfo.networkId);
        } catch (error) {
            console.error(`Error switching to ${chainInfo.name} chain:`, error);

            // Setting the dropdown value based on the currently selected chain
            const matchedChainKey = Object.keys(CHAIN_CONNECTIONS).find(key => CHAIN_CONNECTIONS[key].networkId === chainId);
            setSelectedValue(CHAIN_IDS[matchedChainKey]);  // Passing the Chain ID (e.g., 1, 2, 3...)

            console.log(`Fallback to previously selected chain`);
        }
    }

    function submitZKPWidget() {
        let userMessageSettleZKP =
        {
            view: 2
        }
        setUserMessage(userMessageSettleZKP)
        setShowWidget(true);
    }

    // return DOM
    return (
        <div className="LandingPage">
            <WaterRippleCursor />
            <Header>
                <button className="submitZKPMargin primary-button" onClick={submitZKPWidget}>Submit ZKP</button>
                <CustomDropdown className="centerVertical" onChange={switchNet} selectedValue={selectedValue} />
                <button className="secondary-button" id="connectBtn" onClick={connect}>Connect</button>
            </Header>
            <div className="main">
                <div className="container-box-1">
                    <div className="text-center my-">
                        <h1>
                            SurferMonkey's<br></br>Playground
                        </h1>
                        <h2>Blockchain Privacy and<br></br>Compliance Abstraction</h2>
                        <h2 className="marginBottom" style={{ fontSize: '30px' }}>Universal zkMixer: Compliant, Intent Based<br></br>and Multi-Chain </h2>
                        <div className="metamask-prompt">
                            <h3 style={{ marginTop: '30px' }} >Connect in MetaMask</h3>
                            <img style={{ marginTop: '25px', marginRight: '270px' }} src={MetaMask} alt="MetaMask" className="metamask-image" />
                        </div>
                    </div>
                </div>
                <div id="LandingImageID" className="landingImage">
                    <img src={LandingImage} alt="LandingImage" />

                </div>
                <div id="Sidebar" style={{ display: 'none' }}>
                    <Sidebar
                        blockchainInfo={blockchainInfo}
                        setUserMessage={setUserMessage}
                        setShowWidget={setShowWidget}
                    />
                </div>
                {showWidget && <SurferMonkeyWidget userMessage={userMessage} onClose={closeWidget} />}
                <div id="wrong" className='wrongNet black-box-netIds' style={{ display: 'none' }}>
                    <div className="metamask-prompt text-xl">
                        <b>Connect in Metamask</b>
                        <img src={MetaMask} alt="MetaMask" className="metamask-image" />
                    </div>
                    <ol className="network-list">
                        {supportedNetworks.map((network, index) => (
                            <li key={index}>{network}</li>
                        ))}
                    </ol>
                </div>
            </div>
            <div className='AllNetIds'>
                <Carousel supportedNetworks={supportedNetworks} velocity={2} />
            </div>
        </div>
    );
}

export default LandingPage;